import Splide from '@splidejs/splide';

/**
 * Module Init
 */
(() => {
  const moduleSelector = '.locations';
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  const stateNames = {
    AL: 'Alabama',
    AK: 'Alaska',
    AZ: 'Arizona',
    AR: 'Arkansas',
    CA: 'California',
    CO: 'Colorado',
    CT: 'Connecticut',
    DE: 'Delaware',
    FL: 'Florida',
    GA: 'Georgia',
    HI: 'Hawaii',
    ID: 'Idaho',
    IL: 'Illinois',
    IN: 'Indiana',
    IA: 'Iowa',
    KS: 'Kansas',
    KY: 'Kentucky',
    LA: 'Louisiana',
    ME: 'Maine',
    MD: 'Maryland',
    MA: 'Massachusetts',
    MI: 'Michigan',
    MN: 'Minnesota',
    MS: 'Mississippi',
    MO: 'Missouri',
    MT: 'Montana',
    NE: 'Nebraska',
    NV: 'Nevada',
    NH: 'New Hampshire',
    NJ: 'New Jersey',
    NM: 'New Mexico',
    NY: 'New York',
    NC: 'North Carolina',
    ND: 'North Dakota',
    OH: 'Ohio',
    OK: 'Oklahoma',
    OR: 'Oregon',
    PA: 'Pennsylvania',
    RI: 'Rhode Island',
    SC: 'South Carolina',
    SD: 'South Dakota',
    TN: 'Tennessee',
    TX: 'Texas',
    UT: 'Utah',
    VT: 'Vermont',
    VA: 'Virginia',
    WA: 'Washington',
    WV: 'West Virginia',
    WI: 'Wisconsin',
    WY: 'Wyoming',
    DC: 'District of Columbia',
  };

  $.ajax({
    url: '/branches-list',
    success(branches) {
      branches.forEach((branchData, index) => {
        modules.forEach((module) => {
          const pins = module.querySelector('.pins');
          const pin = document.createElement('a');
          pin.classList.add('pin');
          pin.classList.add(`pin-${branchData.id}`);
          pin.setAttribute('data-index', index);
          pins.appendChild(pin);

          module.querySelector('.splide__list').insertAdjacentHTML('beforeend', /* html */ `
            <div class="splide__slide" data-index="${index}">
              <div class="content-wrapper">
                <h2 class="name">${branchData.address?.city}, ${stateNames[branchData.address?.state]}</h2>
                ${branchData.short_description ? `<div class="short-description">
                  <p class="value">${branchData.short_description}</p>
                </div>` : ''}
                ${branchData.email ? `<div class="email">
                  <a class="value" href="mailto:${branchData.email}">${branchData.email}</a>
                </div>` : ''}
                ${branchData.phone ? `<div class="phone">
                  <a class="value" href="tel:${branchData.phone}">${branchData.phone}</a>
                </div>` : ''}
                ${branchData.address?.line1 ? `<div class="address">
                  <a class="value" target="_blank" href="https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${branchData.address?.line1}, ${branchData.address?.zip}`)}">${branchData.address?.line1}, ${branchData.address?.city}, <br>${branchData.address?.state} ${branchData.address?.zip}</a>
                </div>` : ''}
                <a href="https://www.sumnerone.com/locations" target="_blank" class="btn-custom primary">See Location Details</a>
              </div>
            </div>
          `);
        });
      });
      initSplide();
    },
    error(error) {
      console.error('Failed to load branches data:', error);
    },
  });

  function initSplide() {
    document.querySelectorAll('.locations .splide').forEach((item) => {
      const slider = new Splide(item, {
        type: 'slide',
        rewind: true,
        perPage: 1,
        perMove: 1,
        gap: 0,
        pagination: false,
        arrows: false,
        autoplay: true,
        speed: 1500,
      });

      slider.on('moved', (newIndex) => {
        document.querySelectorAll('.locations-map .pin').forEach((pin) => {
          pin.classList.remove('active');
        });

        const activePin = document.querySelector(`.locations-map .pin[data-index="${newIndex}"]`);
        if (activePin) {
          activePin.classList.add('active');
        }
      });

      // Add click for pins
      document.querySelectorAll('.locations-map .pin').forEach((pin) => {
        pin.addEventListener('click', (e) => {
          e.preventDefault();
          const pinIndex = pin.getAttribute('data-index');
          slider.go(parseInt(pinIndex, 10));
        });
      });

      slider.mount();
    });
  }

  setTimeout(() => {
    window.dispatchEvent(new Event('resize'));
  }, 500);
})();
